export class DirectoryDto {
    id = -1;
    name = '';
    ownerPrincipalId = -1;
    childDirectories: DirectoryDto[] = [];
}
